import { useEffect, useRef } from "react";
var globalChatControl = null;
export var registerChatControl = function (control) {
    globalChatControl = control;
};
export var unregisterChatControl = function () {
    globalChatControl = null;
};
/**
 * Hook to open the chat window and focus the text area
 * @returns A function that opens the chat and focuses the input
 */
export var useOpenChat = function () {
    return function () {
        if (globalChatControl) {
            globalChatControl.openChat();
        }
        else {
            console.warn("Chat control not initialized. Make sure ChatClient is mounted.");
        }
    };
};
/**
 * Hook to open the chat window and insert a pre-written message
 * @returns A function that accepts a message string, opens the chat, and inserts the message
 */
export var useOpenChatWithMessage = function () {
    return function (message) {
        if (globalChatControl) {
            globalChatControl.openChatWithMessage(message);
        }
        else {
            console.warn("Chat control not initialized. Make sure ChatClient is mounted.");
        }
    };
};
/**
 * Hook to open the chat window and immediately send a message (no pre-fill)
 * @returns A function that accepts a message string, opens the chat, and sends it
 */
export var useOpenChatAndSend = function () {
    return function (message) {
        if (globalChatControl) {
            globalChatControl.openChatAndSend(message);
        }
        else {
            console.warn("Chat control not initialized. Make sure ChatClient is mounted.");
        }
    };
};
/**
 * Hook to get the current chat state
 * @returns An object with chat control methods and state
 */
export var useChatControl = function () {
    var stateRef = useRef({ isOpen: false });
    useEffect(function () {
        if (globalChatControl) {
            stateRef.current.isOpen = globalChatControl.isOpen;
        }
    }, []);
    return {
        openChat: useOpenChat(),
        openChatWithMessage: useOpenChatWithMessage(),
        closeChat: function () {
            if (globalChatControl) {
                globalChatControl.closeChat();
            }
        },
        isOpen: stateRef.current.isOpen,
    };
};
